import { render, staticRenderFns } from "./PlaylistWidget.vue?vue&type=template&id=3a8e9312&scoped=true&"
import script from "./PlaylistWidget.vue?vue&type=script&lang=js&"
export * from "./PlaylistWidget.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistWidget.vue?vue&type=style&index=0&id=3a8e9312&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e9312",
  null
  
)

export default component.exports